<template>
  <div>
    <div style="padding: 30px">
      <el-form :model="formData" :rules="formRules" ref="formRef" size="small" label-width="80px">
        <el-form-item label="原密码" prop="password" :error="errMsg.password" autocomplete="off">
          <el-input v-model="formData.password" show-password> </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" :error="errMsg.newPassword" autocomplete="off">
          <el-input v-model="formData.newPassword" show-password> </el-input>
          <span>8位以上必须含数字大小写字母</span>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="formData.confirmPassword" show-password autocomplete="off"> </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-but">
      <el-button size="small" type="primary" @click="saveData()">修 改</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'changePassword',
  data() {
    var verifyPassword = (rule, value, callback) => {
      var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
      if (!regex.test(value)) {
        callback(new Error('密码不符合规则'))
      } else {
        callback()
      }
    }
    var verifyConfirmPassword = (rule, value, callback) => {
      if (this.formData.newPassword != value) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      errMsg: {},
      formData: { password: '', newPassword: '', confirmPassword: '' },
      formRules: {
        password: [{ required: true, message: '原密码不能为空', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: verifyPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: verifyConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    //保存
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (vaild) {
          this.initErrMsg()
          await this.$api.admin.changePassword(this.formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.formData = { password: '', newPassword: '', confirmPassword: '' }
              this.$emit('callMethod')
            } else {
              for (let k in res.data) {
                this.errMsg[k] = res.data[k]
              }
            }
          })
        }
      })
    },
    //父页面传数据
    setData() {
      this.formData = { password: '', newPassword: '', confirmPassword: '' }
      this.initErrMsg()
      this.$refs.formRef.clearValidate()
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {}
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '')
      })
    }
  }
}
</script>
